import Vue from 'vue';
import 'primeicons/primeicons.css';

import PrimeVue from 'primevue/config';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import Textarea from 'primevue/textarea';
import ProgressSpinner from 'primevue/progressspinner';
import Slider from 'primevue/slider';
import InputSwitch from 'primevue/inputswitch';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Password from 'primevue/password';
import Tooltip from 'primevue/tooltip';

Vue.use(PrimeVue, {
    locales: {
        hu: {
            firstDayOfWeek: 1,
            dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
            dayNamesShort: ['Vas', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo'],
            dayNamesMin: ['Vas', 'Hé', 'Ke', 'Sze', 'Csü', 'Pé', 'Szo'],
            monthNames: [
                'Január',
                'Február',
                'Március',
                'Április',
                'Május',
                'Június',
                'Július',
                'Augusztus',
                'Szeptember',
                'Október',
                'November',
                'December',
            ],
            monthNamesShort: ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szep', 'Okt', 'Nov', 'Dec'],
            today: 'Ma',
            clear: 'Törlés',
            dateFormat: 'nn/hh/éééé',
            weekHeader: 'Hét',
        },
        en: {
            firstDayOfWeek: 1,
            dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            monthNames: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            today: 'Today',
            clear: 'Clear',
            dateFormat: 'mm/dd/yy',
            weekHeader: 'Wk',
        },
    },
});

Vue.component('InputText', InputText);
Vue.component('Password', Password);
Vue.component('InputNumber', InputNumber);
Vue.component('Textarea', Textarea);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('Slider', Slider);
Vue.component('InputSwitch', InputSwitch);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('Checkbox', Checkbox);
Vue.component('Dropdown', Dropdown);
Vue.component('Calendar', Calendar);
Vue.component('Button', Button);
Vue.directive('Tooltip', Tooltip);
